export const convertBytearrToImg = (buffer: ArrayBufferLike) => {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var j = 0; j < len; j++) {
      binary += String.fromCharCode(bytes[j]);
    }
    var base64String = window.btoa(binary);
    return "data:image/png;base64," + base64String
  }

  export async function applyBlackMask(base64Image: string): Promise<string> {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = base64Image;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) return;

            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            // Get image data
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            // Iterate over each pixel
            for (let i = 0; i < data.length; i += 4) {
                // Set the RGB values to 0 (black), keep the alpha value unchanged
                data[i] = 0;     // Red
                data[i + 1] = 0; // Green
                data[i + 2] = 0; // Blue
                // data[i + 3] is the alpha channel
            }

            // Put the modified image data back on the canvas
            ctx.putImageData(imageData, 0, 0);

            const maskedImage = canvas.toDataURL('image/png');
            resolve(maskedImage);
        };
    });
}